import { takeLatest, put } from 'redux-saga/effects'
import { Types } from '../ducks/customer'
import { graphClient } from './auth'
import { notifyError } from '../../utils/notify'

function* getProject() {
  try {
    const listId = '4b867da1-adcb-4b53-a1f3-0e789ac460c3'
    const siteId = 'root'
    const projectTitle = 'Inventário Arborização Ribeirão Preto'

    const res = yield graphClient
      .api(`sites/${siteId}/lists/${listId}/items?filter=fields/Title eq '${projectTitle}'&expand=fields`)
      .header('Prefer', 'allowthrottleablequeries')
      .get()

    console.tron.log('getProject res', res.value[0])

    const endpoint = "/sites/ecossissolucoes.sharepoint.com:/projetos:/lists/9f87ed00-e9e6-45e7-8296-37a76af3f332/items?$filter=fields/ProjetoLookupId eq '94'&expand=fields"
    const res2 = yield graphClient
      .api(endpoint)
      .header('Prefer', 'allowthrottleablequeries')
      .get()
    console.tron.log('getProducts res2', res2)

    yield put({
      type: Types.GET_PROJECT_SUCCEEDED,
      payload: res.value[0],
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar o projeto. Tente novamente mais tarde.')
    yield put({
      type: Types.GET_PROJECT_FAILED,
    })
  }
}

export const customerSagas = [
  takeLatest(Types.GET_PROJECT_REQUESTED, getProject),
]
